var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { createAction } from "typesafe-actions";
import { getQuizInfo } from "../services/quizService";
import * as userActions from "./user/actions";
import * as backendAddressActions from "./backendAddress/actions";
import * as customizationActions from "./customization/actions";
import * as feedbackDisplayedActions from "./feedbackDisplayed/actions";
import * as languageActions from "./language/actions";
import * as loadingBars from "./loadingBars/actions";
import * as quizActions from "./quiz/actions";
import * as quizAnswerActions from "./quizAnswer/actions";
import * as messageActions from "./message/actions";
export var clearActionCreator = createAction("CLEAR");
export var initialize = function initialize(id, languageId, accessToken, backendAddress, fullInfoWithoutLogin, showZeroPointsInfo) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var fullInfo, responseData, quiz, quizAnswer, userQuizState, loginResponse, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (showZeroPointsInfo === undefined) {
              showZeroPointsInfo = true;
            }

            dispatch(clearActionCreator());
            dispatch(languageActions.set(languageId));

            if (backendAddress) {
              dispatch(backendAddressActions.set(backendAddress));
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            fullInfo = !!(accessToken || fullInfoWithoutLogin);
            dispatch(loadingBars.InitializeLoadingBarsAfterDelay());
            return [4, getQuizInfo(id, accessToken, backendAddress, fullInfo)];

          case 2:
            responseData = _a.sent();
            quiz = void 0, quizAnswer = void 0, userQuizState = void 0;

            if (responseData.id) {
              quiz = responseData;
            } else {
              loginResponse = responseData;
              quiz = loginResponse.quiz;
              quizAnswer = loginResponse.quizAnswer;
              userQuizState = loginResponse.userQuizState;
            }

            dispatch(customizationActions.modify_show_points_info(showZeroPointsInfo || quiz && quiz.points > 0));

            if (!accessToken) {
              dispatch(quizAnswerActions.setQuizDisabled(true));
            }

            dispatch(quizActions.set(quiz));

            if (!accessToken) {
              return [2];
            }

            if (quiz.deadline && new Date(quiz.deadline).getTime() < new Date().getTime()) {
              dispatch(quizAnswerActions.pastDeadline());
            }

            if (!quizAnswer) {
              quizAnswer = {
                quizId: quiz.id,
                languageId: languageId,
                itemAnswers: quiz.items.map(function (item) {
                  return {
                    quizItemId: item.id,
                    textData: "",
                    intData: null,
                    optionAnswers: []
                  };
                })
              };
            }

            dispatch(userActions.setToken(accessToken));
            dispatch(quizAnswerActions.setAnswer(quizAnswer));

            if (userQuizState && (userQuizState.status !== "open" || userQuizState.pointsAwarded && Math.abs(userQuizState.pointsAwarded - quiz.points) < 0.001)) {
              dispatch(feedbackDisplayedActions.display());
            }

            if (userQuizState) {
              dispatch(userActions.setUserQuizState(userQuizState));
            }

            return [3, 4];

          case 3:
            e_1 = _a.sent();
            dispatch(messageActions.fatalErrorOccurred(getState().language.languageLabels.error.quizLoadFailedError || e_1.toString()));
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };
};